import { createRouter } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import type { AuthState } from "./auth/AuthProvider";
import { routeTree } from "./routeTree.gen";

export function createAppRouter(queryClient: QueryClient) {
  return createRouter({
    routeTree,
    // The real auth value is injected per-render by main.tsx via
    // <RouterProvider context={{ auth, queryClient }} />.
    context: { auth: undefined as unknown as AuthState, queryClient },
    defaultPreload: "intent",
  });
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof createAppRouter>;
  }
}
